/* ============
 * All Product Types
 * ============
 *
 * All product types.
 */

import Vue from 'vue';
import store from '../../store';
import partnerTransformer from '../../transformers/partner';

const success = ({ data }, resolve) => {
  const partners = partnerTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllPartners', partners);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display product types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('partners')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/partner/all.js